import React from 'react'
import {Icon} from '@chakra-ui/react'

const CopyIcon = (props) => {
    return (
        <Icon viewBox="0 0 18 18" fill="none" data-testid="copy-icon" {...props}>
            <g clipPath="url(#clip0_378_16)">
                <path
                    d="M15 6H7.5C6.67157 6 6 6.67157 6 7.5V15C6 15.8284 6.67157 16.5 7.5 16.5H15C15.8284 16.5 16.5 15.8284 16.5 15V7.5C16.5 6.67157 15.8284 6 15 6Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3 12C2.175 12 1.5 11.325 1.5 10.5V3C1.5 2.175 2.175 1.5 3 1.5H10.5C11.325 1.5 12 2.175 12 3"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_378_16">
                    <rect width="18" height="18" fill="none" />
                </clipPath>
            </defs>
        </Icon>
    )
}

export default CopyIcon
